import { cn } from "@/lib/cn"
import { RichTranslationValues, useTranslations } from "next-intl"
import { HTMLAttributes } from "react"
import { Translate } from "../translate"
import { Img } from "./image"

type ErrorBannerProps = {
  title?: string
  body: string
  bodyValues?: RichTranslationValues
} & HTMLAttributes<HTMLDivElement>

export function ErrorBanner({
  body,
  bodyValues,
  title,
  ...rest
}: ErrorBannerProps) {
  const t = useTranslations()

  return (
    <div
      className={cn(
        "border-banner-error-border bg-banner-error mx-auto flex w-full gap-2 border-b-2 p-2 md:mt-4 md:max-w-[31.125rem]",
        { "cursor-pointer": rest.onClick != null },
      )}
      {...rest}
    >
      <div>
        <Img
          className="min-w-4"
          src={
            window.APP_VENDOR === "snai"
              ? "/assets/banner/snai/error.svg"
              : "/assets/banner/error.svg"
          }
          width={16}
          height={16}
          alt="error banner icon"
        />
      </div>
      <div className="flex flex-col gap-1">
        {title && (
          <h4 className="font-secondary text-title-s font-bold">{t(title)}</h4>
        )}
        <p className="text-title-xs">
          <Translate i18nKey={body} values={bodyValues} />
        </p>
      </div>
    </div>
  )
}
